<template>
  <dialog-add
    icon="inventory"
    :title="$t('new_event_promotion')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-events-promotion-banner class="elevation-1" @saved="$emit('saved')" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      const { step, ...listQuery } = this.$route.query;
      this.$router.push({ name: 'event-promotions', query: listQuery });
    },
  },
};
</script>
